import FacilitiesData from "../../components/hotel/datamanagement/FacilitiesData";

export default function FacilitiesPage() {
  return <FacilitiesData />;
}

